import React from 'react'
import { makeBalloonContent, parseGeoPoint, makePlacemarkIcon } from '../lib/common'
import { MAP_DEFAULT_STATE } from '../lib/config'

import { YMaps, Map } from 'react-yandex-maps'
import DevelopersMapPlacemark from './DevelopersMapPlacemark'

function DevelopersMap ({ developers = [] }) {
  return <YMaps>
    <Map
      className="developer-map"
      defaultState={ MAP_DEFAULT_STATE }
      modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}
    >
      { developers.map((developer, index) => (
        <DevelopersMapPlacemark
          key={ index }
          coordinates={ parseGeoPoint(developer.geo) }
          content={ makeBalloonContent(developer) }
          icon={ makePlacemarkIcon(developer) }
        />
      ))}
    </Map>
  </YMaps>
}

export default (DevelopersMap)